import React from "react";
import { TextArea } from "component-library";
import { useTranslation } from "i18n";
import { CrossThickIcon } from "assets";

import "./CastingDirectorNotes.scss";

const MAX_LENGTH = 1000;

export interface ICastingDirectorNotesProps {
  notes?: string;
  changeNotes: (notes: string) => void;
  closeNotes: () => void;
}

export const CastingDirectorNotes: React.FC<
  React.PropsWithChildren<ICastingDirectorNotesProps>
> = (props) => {
  const { notes, changeNotes, closeNotes } = props;
  const { t } = useTranslation();

  return (
    <div className="c-casting-director-notes__form">
      <button
        type="button"
        className="c-casting-director-notes__close dark:text-color-neutral-one"
        onClick={closeNotes}
        aria-label={t("common:aria.label.closeCastingDirectorNotes")}
      >
        <CrossThickIcon />
      </button>
      <TextArea
        value={notes}
        valueChanged={changeNotes}
        autoResize
        isLoading={notes === undefined}
        showsCharacterCount
        maxLength={MAX_LENGTH}
      />
    </div>
  );
};
